import React, { useEffect, useRef, useState } from 'react';
import { useUser } from '../context/UserContext';
import './AdBanner.css';

const ADSENSE_CLIENT = 'ca-pub-8821911563467539';

const AD_SLOTS = {
  'swipe-bottom':      '6493288243',
  'explore-mid':       '2968976204',
  'book-detail':       '3020617523',
  'reader-mid':        '5232177464',
  'feed-inline':       '8799412029',
  'feed-top':          '7479136665',
  'feed-bottom':       '5527285382',
  'shop-top':          '9338613861',
  'trending-top':      '4653187417',
  'trending-bottom':   '2613822799',
  'contest-mid':       '4525670268',
  'contest-bottom':    '3340105747',
  'leaderboard-top':   '6916534463',
  'leaderboard-bottom':'4214203711',
  'default':           '7777777777',
};

// Pages autorisées pour les pubs (avec du vrai contenu)
const ALLOWED_SLOTS = [
  'book-detail',
  'reader-mid',
  'explore-mid',
  'feed-inline',
  'feed-top',
  'feed-bottom',
  'trending-top',
  'trending-bottom',
];

export default function AdBanner({ slot = 'default', format = 'horizontal', hasContent = true }) {
  const { user } = useUser();
  const adRef = useRef(null);
  const [adError, setAdError] = useState(false);
  const pushed = useRef(false);

  useEffect(() => {
    if (!ADSENSE_CLIENT || ADSENSE_CLIENT === 'ca-pub-8821911563467539') return;
    if (pushed.current) return;

    const timer = setTimeout(() => {
      if (adRef.current && window.adsbygoogle) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          pushed.current = true;
        } catch (e) {
          console.warn('AdSense push error:', e);
          setAdError(true);
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [slot]);

  // Premium = pas de pub
  if (user?.premium) return null;

  // Pas de pub si pas connecté (pages trop vides)
  if (!user) return null;

  // Pas de pub si le slot n'est pas dans la liste autorisée
  if (!ALLOWED_SLOTS.includes(slot)) return null;

  // Pas de pub si la page n'a pas assez de contenu
  if (!hasContent) return null;

  // Placeholder si pas encore configuré
  if (!ADSENSE_CLIENT || ADSENSE_CLIENT === 'ca-pub-XXXXXXXXX') {
    return (
      <div className={'ad-banner ad-banner-' + format}>
        <div className="ad-banner-placeholder">
          <p className="ad-banner-text">Publicité</p>
          <p className="ad-banner-upgrade">
            Passe à <strong>Plumly Premium</strong> pour supprimer les pubs
          </p>
        </div>
      </div>
    );
  }

  if (adError) return null;

  const adSlotId = AD_SLOTS[slot] || AD_SLOTS['default'] || slot;
  const adFormat = format === 'small' ? 'fluid' : 'auto';
  const layoutKey = format === 'small' ? '-6t+ed+2i-1n-4w' : undefined;

  return (
    <div className={'ad-banner ad-banner-' + format} ref={adRef}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={adSlotId}
        data-ad-format={adFormat}
        data-full-width-responsive="true"
        {...(layoutKey ? { 'data-ad-layout-key': layoutKey } : {})}
      />
    </div>
  );
}